import { COLORS } from '@app/constants';
import React, { useContext, useEffect, useState } from 'react';
import { View } from '@/styles/reactnative';
import TpslCheckBox from './TpslCheckBox';
import TpslDetail from './TpslDetail';
import useTradeStore from '../../../../../../hooks/trade/tradeStore';
import { ThemeContext } from '@/theme/ThemeProvider.tsx';
import { Flex, Input } from 'antd';
import { MText } from '@/styles/mobilePageStyles.tsx';
import { isMobile } from 'react-device-detect';
import { useIsMobile, useIsTablet } from '@utils/CalVW.tsx';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';
import styled from 'styled-components';
import { CButton } from '@/app/components/Common';
import BigNumber from 'bignumber.js';
import CheckBox from '@/app/components/CheckBox';
import TimeInForceDropdown from '../DerivativesCheckBoxs/TimeInForceDropdown';

const DerivativesTpSl = () => {
  const { data: tradeStore, mutate } = useTradeStore();
  const { t } = useTranslation();

  const [buyTpsl, setBuyTpsl] = useState<boolean>(false);
  const [display, setDisplay] = useState<boolean>(false);
  const [tpslPercentage, setTpslPercentage] = useState('');
  const [stopLossPercentage, setStopLossPercentage] = useState('');
  const [tpslValue, setTpslValue] = useState('');
  const [stopLossValue, setStopLossValue] = useState('');
  const [tradeTpslType, setTradeTpslType] = useState('USDT');
  const [tradeLossType, setTradeLossType] = useState('USDT');
  const isMobile = useIsMobile();

  const isLimitOrder = tradeStore?.limit_market === "L";

  useEffect(() => {
    setBuyTpsl(false);
  }, [tradeStore?.ep_id]);

  useEffect(() => {
    mutate({
      ...tradeStore,
      tpsl: buyTpsl,
      tp: tpslValue,
      sl: stopLossValue,
      tptype: tradeTpslType,
      sltype: tradeLossType,
    });
  }, [buyTpsl, tpslValue, stopLossValue, tradeTpslType, tradeLossType]);

  useEffect(() => {
    setDisplay(buyTpsl);
  }, [buyTpsl]);

  return (
    <View
      style={{
        width: '100%',
        padding: '12px 12px 0 12px',
        gap: 12,
      }}
    >
      {/* TP/SL와 Reduce-Only 체크박스를 가로로 배치 */}
      <View
        style={{
          width: '100%',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: 24,
        }}
      >
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: 6,
          }}
        >
          <CheckBox checked={buyTpsl} setChecked={setBuyTpsl} />
          <div
            style={{
              fontSize: 12,
              color: '#fff',
              fontFamily: 'NanumSquareRound',
              letterSpacing: '-0.36px',
            }}
          >
            TP/SL
          </div>
        </View>

        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: 6,
          }}
        >
          <CheckBox
            checked={tradeStore?.reduce_only}
            setChecked={(checked) =>
              mutate({ ...tradeStore, reduce_only: checked })
            }
          />
          <div
            style={{
              fontSize: 12,
              color: '#fff',
              fontFamily: 'NanumSquareRound',
              letterSpacing: '-0.36px',
            }}
          >
            {t('reduceOnly')}
          </div>
        </View>

        {isLimitOrder && <View style={{ flex:1, alignItems: 'flex-end' }}><TimeInForceDropdown /></View>}
      </View>

      {display ? (
        <div
          style={{
            padding: '0',
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            width: '100%',
          }}
        >
          <TPSLCustomRow
            type={'tp'}
            isSmall={false}
            price={0}
            amount={0}
            positionType={'entire'}
          />

          <TPSLCustomRow
            type={'sl'}
            isSmall={false}
            price={0}
            amount={0}
            positionType={'entire'}
          />
        </div>
      ) : null}
    </View>
  );
};

export default DerivativesTpSl;

const TPSLCustomRow = (props: {
  type: 'tp' | 'sl';
  price?;
  amount?;
  leverage?;
  margin?;
  long_short?;
  defaultValue?;
  value?;
  setValue?;
  isMobile?: boolean;
  isSmall?: boolean;
  positionType?: 'entire' | 'partial';
}) => {
  const {
    theme: { COLORS },
    isDarkMode,
  } = useContext(ThemeContext);

  const { textw, gray, bgColor, mobileTradeBorder, textsilver } = COLORS;

  const { data: tradeStore, mutate: setTradeStore } = useTradeStore();

  const isMobile = useIsMobile();
  const isTablet = useIsTablet();

  const [targetPrice, setTargetPrice] = useState(isMobile ? '0' : '');

  const handleChange = (e) => {
    const inputValue = e.target.value;

    // 빈 값이면 그대로
    if (inputValue === '') {
      setTargetPrice('');
      if (props.type === 'tp') {
        setTradeStore({ ...tradeStore, tp: '' });
      } else {
        setTradeStore({ ...tradeStore, sl: '' });
      }
      return;
    }

    const dp = tradeStore?.dp || 3;

    // 소수점이 있는지 체크
    const decimalIndex = inputValue.indexOf('.');

    if (decimalIndex !== -1) {
      // 소수점 이하 자리수 계산
      const decimalPlaces = inputValue.length - decimalIndex - 1;

      // dp를 초과하면 입력을 막음
      if (decimalPlaces > dp) {
        return;
      }
    }

    // dp 이하면 입력 허용
    setTargetPrice(inputValue);

    if (props.type === 'tp') {
      setTradeStore({
        ...tradeStore,
        tp: inputValue,
      });
    } else {
      setTradeStore({
        ...tradeStore,
        sl: inputValue,
      });
    }
  };

  // blur 시 후행 0 제거
  const handleBlur = () => {
    if (!targetPrice || targetPrice === '') return;

    let finalValue = targetPrice.toString();
    finalValue = finalValue
      .replace(/(\.\d*?[1-9])0+$/, '$1')
      .replace(/\.0+$/, '');

    setTargetPrice(finalValue);
    if (props.type === 'tp') {
      setTradeStore({ ...tradeStore, tp: finalValue });
    } else {
      setTradeStore({ ...tradeStore, sl: finalValue });
    }
  };

  const handleChangeButton = (type: 'plus' | 'minus') => {
    if (type === 'plus') {
      const newTargetPrice = new BigNumber(targetPrice).plus(1).toString();
      setTargetPrice(newTargetPrice);
      setTradeStore({
        ...tradeStore,
        tp: newTargetPrice,
      });
    } else {
      const newTargetPrice = new BigNumber(targetPrice).minus(1).toString();
      setTargetPrice(newTargetPrice);
      setTradeStore({
        ...tradeStore,
        sl: newTargetPrice,
      });
    }
  };

  const label =
    props.type === 'tp' ? t('TakeProfitSetting') : t('StopLossSetting');
  const smalllabel = props.type === 'tp' ? t('TakeProfit') : t('StopLoss');

  return (
    <Flex
      vertical
      align={'start'}
      gap={props.isMobile ? 'middle' : 4}
      style={{ width: '100%' }}
    >
      <MText
        style={{
          color: '#B3B5BD',
          fontSize: 12,
          fontFamily: 'NanumSquareRound',
          lineHeight: 1,
        }}
      >
        {props.isSmall ? smalllabel : label}
      </MText>
      <CustomInput
        type="number"
        value={targetPrice}
        onChange={handleChange}
        onBlur={handleBlur}
        step={Math.pow(10, -(tradeStore?.dp || 3)).toString()}
        size={props.isMobile ? 'middle' : undefined}
        suffix={
          <div
            style={{
              fontSize: 12,
              fontWeight: 700,
              fontFamily: 'NanumSquareRound',
            }}
          >
            USDT
          </div>
        }
        isTablet={isTablet}
        isSmall={props.isSmall}
      />
    </Flex>
  );
};

const MContainer = styled.div<{ isDarkMode: boolean }>`
  border-radius: 6px;
  background: gray;
  color: textw;
  margintop: 5;
  padding: 4px 12px;
  width: 100%;
  background-color: ${({ isDarkMode }) => (isDarkMode ? '#0C110E' : '#F8F4F0')};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CustomInput = styled(Input)<{
  isTablet: boolean;
  isSmall: boolean | undefined;
}>`
  width: ${({ isTablet, isSmall }) =>
    isTablet ? '100%' : isSmall ? '12.5vw' : '100%'};
  color: #e9e9ed;
  background-color: #2a2c2e;
  padding: 4px 12px;
  border-radius: 6px;
  border: 1px solid transparent;
  font-family: 'NanumSquareRound';

  &:focus {
    background-color: #2a2c2e;
    border: 1px solid rgba(255, 255, 255, 0.12);
  }

  &:hover {
    background-color: #2a2c2e;
    border: 1px solid rgba(255, 255, 255, 0.12);
  }
`;
